import { CSSProperties, ReactElement, useCallback } from 'react';
import { GroupBase, SingleValueProps } from 'react-select';

export function SingleValue<T>(
  props: SingleValueProps<any, boolean, GroupBase<T>>,
  customSingleValue?: (data: T) => ReactElement | null
): ReactElement | null {
  const { children, getStyles, data } = props;

  const getOption = useCallback(() => {
    if (customSingleValue) {
      return customSingleValue(data);
    } else return <p>{children}</p>;
  }, []);

  return <div style={getStyles('singleValue', props) as CSSProperties}>{getOption()}</div>;
}
